import React, { useState, useEffect, useCallback } from 'react';
import { Form, Button, Row, Col, Card, Alert, InputGroup } from 'react-bootstrap';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import ImageCropper from '../Utils/ImageCropper';
import PhoneInput from '../Input/PhoneInput'
import { useProvider, Toast, isNative } from '../../context/MenuProvider';
import SelecionarCategoria from '../Utils/SelecionarCategoria';
import { AppLauncher } from '@capacitor/app-launcher';
import { Geolocation } from '@capacitor/geolocation';
import { Localizacao } from '../Utils/PerfilParte';

const ClienteForm = ({links}) => {
    const { id, tipo } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const enviar_whatsapp = queryParams.get('enviar_whatsapp')?.toLowerCase() === 'true';
    const is_venda = queryParams.get('is_venda')?.toLowerCase() === 'true';

    const navigate = useNavigate();
    const [foto, setFoto] = useState('');
    const [fileFoto, setFileFoto] = useState(null);
    const [telefone, setTelefone] = useState('');
    const [nomeDoCliente, setNomeDoCliente] = useState('');
    const [documento, setDocumento] = useState('');
    const [endereco, setEndereco] = useState('');
    const [posicao, setPosicao] = useState('');
    const [enderecos, setEnderecos] = useState('');
    const [enderecoAtual, setEnderecoAtual] = useState('');
    const [diaDoAniversario, setDiaDoAniversario] = useState('');
    const [ativo, setAtivo] = useState(true);
    const [enviarWhatsApp, setEnviarWhatsApp] = useState(!!enviar_whatsapp);
    const [observacoes, setObservacoes] = useState('');
    const [crediario, setCrediario] = useState(true);
    const [regiao, setRegiao] = useState('');
    const [regioes, setRegioes] = useState([]);
    const [formErrors, setFormErrors] = useState({});
    const [mais, setMais] = useState(id?true:false);
    
    const [categoriaId, setCategoriaId] = useState();
    
    const { 
      setLinks, 
      setBtns,
      crud,
      auth,
      salvarDados,
      buscarDados,
      setTitle,
      site,
      handleEnviarWhats,
      handleNormalizarTelefone,
      handleFormatarTelefone,
    } = useProvider();
    
    const { post, patch, put, get, loading } = crud || {};// useCrud(`/gvendas/clientes/${id || ''}${id?'/':''}`, token, 'multipart/form-data');
    
    const salvarContatoDispositivo = async (nome, telefone, email = '') => {
      try {
        const telefoneLimpo = handleNormalizarTelefone(telefone);
        if (id || !isNative || !telefoneLimpo || !nome) return;
    
        const { Contacts } = await import("@capacitor-community/contacts");
        const permission = await Contacts.requestPermissions();
        if (permission.contacts !== 'granted') return;
    
        // Otimização Máxima: Buscamos apenas os números de telefone de TODOS os contatos.
        // É mais rápido baixar uma lista de strings do que pedir para o SO filtrar por nós.
        const result = await Contacts.getContacts({
          projection: {
            phones: true 
          }
        });
    
        // Verificação ultra-rápida em memória
        const contatoExistente = result.contacts.some(c => 
          c.phones?.some(p => handleNormalizarTelefone(p.number) === telefoneLimpo)
        );
    
        if (contatoExistente) {
          Toast.fire({ icon: 'info', title: 'Contato já salvo no dispositivo.' });
          return;
        }
    
        await Contacts.createContact({
          contact: {
            name: { given: nome },
            organization: { company: site?.name || 'GVendas' },
            phones: [{ type: 'mobile', number: telefoneLimpo, label: 'celular' }],
            emails: email ? [{ type: 'work', address: email }] : []
          }
        });
    
        Toast.fire({ icon: 'success', title: 'Contato salvo no dispositivo!' });
      } catch (error) {
        console.error("Erro ao salvar contato:", error);
      }
    };
    
    const handleEnviarWhatsApp = useCallback(async () => {
      try {
        const telefoneLimpo = handleNormalizarTelefone(telefone);
        if (id || !enviarWhatsApp || !telefoneLimpo || is_venda) return;
    
        const nomeClienteFormatado = nomeDoCliente?.trimStart().split(' ')[0];
        const nomeLojaFormatado = auth?.empresa?.nome_da_loja?.trimStart().split(' ')[0];
        const texto = `Oi ${nomeClienteFormatado}, aqui é ${nomeLojaFormatado}`;
        
        if(!isNative){
          // Texto para o clipboard
          const textoCopiado = `${nomeDoCliente} ${endereco ? '(' + endereco + ')' : ''}`;
          await navigator.clipboard.writeText(textoCopiado);
        }
        await handleEnviarWhats(telefoneLimpo, texto);
      } catch (err) {
        //alert(err)
        console.error("Erro:", err);
      }
    },[telefone, enviarWhatsApp, nomeDoCliente, endereco, is_venda, auth, handleEnviarWhats, handleNormalizarTelefone, isNative, id])

    const handleSubmit = useCallback(async (e) => {
        if(e) e.preventDefault();

        const errors = {};
        
        if (nomeDoCliente === '') errors.nomeDoCliente = 'Por favor, informe o nome do cliente.';

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

        setFormErrors({});
        const telefoneFormatado = handleFormatarTelefone(telefone);
        //alert(telefoneFormatado);
        const formData = new FormData();
        if (!tipo){
          formData.append('nome', nomeDoCliente);
          formData.append('telefone', telefoneFormatado);
          formData.append('cpf_cnpj', documento);
          formData.append('aniversario', diaDoAniversario);
        }
        else if(tipo === 'cliente'){
          formData.append('contato.nome', nomeDoCliente);
          formData.append('contato.telefone', telefoneFormatado);
          formData.append('contato.cpf_cnpj', documento);
          formData.append('contato.aniversario', diaDoAniversario);
          
          formData.append('telefone', telefoneFormatado);
          formData.append('nome_do_cliente', nomeDoCliente);
          formData.append('endereco', endereco||``);
          formData.append('observacoes', observacoes);
          formData.append('ativo', ativo);
          formData.append('posicao_mapa', posicao||``);
          formData.append('crediario', crediario);
          formData.append('categoria', categoriaId || ``);
          if (fileFoto) formData.append('foto_perfil', fileFoto);
          if(regiao){
            formData.append('regiao.nome', regiao);
          }else{
            formData.append('regiao', null);
          }
        }

        const apiRequest = id ? patch : post;
        //alert(documento)
        try{
          let url = `/core/contatos/`;
          if (tipo === "cliente"){
            url = `/gvendas/clientes/`
          }
          const response = await apiRequest(formData,`${url}${id || ''}${id?'/':''}`, 'multipart/form-data');
          if (response && response.length){
              await salvarDados("db_clientes", response[0]);
              Toast.fire({
                  icon: "success",
                  title: `Cliente cadastrado com sucesso`
              });
              
              const nomeContato = `${nomeDoCliente} ${endereco ? '(' + endereco + ')' : ''}`;
              salvarContatoDispositivo(nomeContato, telefone);
              await handleEnviarWhatsApp();

              if (is_venda){
                  await salvarDados('local_registros', { 
                    venda: {
                      cliente: response[0],
                    },
                    id:"checkout"
                  });
                  navigate(`/checkout/adicionar-produtos`, { replace: true });
              } else {
                  navigate(-1);
              }
          }
        }catch(err){
          //alert(JSON.stringify(err.response))
          const errorMessage = typeof err.response?.data === 'string' 
                    ? 'Erro ao salvar o cliente.' 
                    : err.response?.data?.detail;
          setFormErrors(prevErrors => ({ ...prevErrors, 
                apiError: errorMessage,
                telefone: err.response?.data?.telefone,
                documento: err.response?.data?.cpf_cnpj,
                nomeDoCliente: err.response?.data?.nome_do_cliente,
                endereco: err.response?.data?.endereco,
                diaDoAniversario: err.response?.data?.dia_do_aniversario,
                ativo: err.response?.data?.ativo,
                observacoes: err.response?.data?.observacoes,
                crediario: err.response?.data?.crediario,
                regiao: err.response?.data?.regiao,
          }));
          
          if (err.code === 'ERR_NETWORK' || err.code === 'ECONNABORTED' || !err.response ) {
            const payload = {
              telefone:telefone||null,
              // cpf_cnpj: documento||null,
              nome_do_cliente: nomeDoCliente,
              // endereco: endereco || '',
              // dia_do_aniversario: diaDoAniversario||null,
              // ativo,
              // posicao_mapa: posicao || '',
              // observacoes,
              // crediario,
              // regiao: regiao ? { nome: regiao } : null,
              // foto_perfil: aqui precisaria converter o arquivo para base64 se quiser incluir no JSON
            };
            await salvarDados('db_sync', {
              metodo: "POST",
              titulo: `Novo contato`,
              descricao: `
                <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr><th>${payload?.nome_do_cliente || 'Cliente não informado'}</th></tr>
                  </thead>
                  <tbody>
                    <tr><td>${payload?.telefone}</td></tr>
                  </tbody>
                </div>
              `,
              url: `/gvendas/clientes/`,
              dados: payload,
              data: new Date().toLocaleString("sv-SE"),
            });
            //Colocar url da fila;
            navigate(`/sync`, { replace: true });
          }
        }finally{
          navigator.clipboard.writeText(`${nomeDoCliente} ${endereco?'('+endereco+')':''}`).then(() => 
            console.log("Texto copiado!")
          ).catch(err => 
            console.error("Erro ao copiar: ", err)
          );
        }
    }, [nomeDoCliente, telefone, documento, diaDoAniversario, tipo, endereco, observacoes, ativo, posicao, crediario, categoriaId, fileFoto, regiao, id, patch, post, salvarDados, handleEnviarWhatsApp, is_venda, navigate, handleFormatarTelefone, salvarContatoDispositivo])
    
    const handleImportContacts = async () => {
      try {
        // ===== APP (Capacitor / APK) =====
        if (isNative) {
          const { Contacts } = await import("@capacitor-community/contacts");
    
          // 1. Verifica e pede permissão
          let permission = await Contacts.checkPermissions();
          if (permission.contacts !== 'granted') {
            permission = await Contacts.requestPermissions();
          }
    
          if (permission.contacts === 'granted') {
            // 2. ABRE A TELA DE SELEÇÃO NATIVA (Igual ao navegador)
            const result = await Contacts.pickContact({
              projection: {
                name: true,
                phones: true,
              },
            });
    
            // O 'pickContact' retorna apenas UM contato selecionado pelo usuário
            if (result?.contact) {
              const c = result.contact;
    
              if (c.phones?.length > 0) {
                // Limpa o número e pega os últimos 11 dígitos
                const tel = c.phones[0].number.replace(/\D/g, '').slice(-11);
                setTelefone(tel);
              }
    
              if (c.name?.display) {
                setNomeDoCliente(c.name.display);
              }
              //Toast.fire({ icon: "success", title: "Contato importado!" });
            }
          } else {
            Toast.fire({ icon: "error", title: "Permissão de contatos negada." });
          }
          return;
        }
    
        // ===== NAVEGADOR / PWA (Permanece igual) =====
        else if ("contacts" in navigator && "select" in navigator.contacts) {
          const contatos = await navigator.contacts.select(["name", "tel"], { multiple: false });
    
          if (contatos?.length > 0) {
            const c = contatos[0];
            if (c.tel?.length > 0) {
              const tel = c.tel[0].replace(/\D/g, '').slice(-11);
              setTelefone(tel);
            }
            if (c.name?.length > 0) {
              setNomeDoCliente(c.name[0]);
            }
            Toast.fire({ icon: "success", title: "Contato importado!" });
          }
        } 
        
        else {
          Toast.fire({ icon: "error", title: "Navegador não suporta Contact Picker." });
        }
      } catch (err) {
        console.error(err);
        // Usuário cancelou a seleção ou erro técnico
        if (err.message !== "User cancelled") {
            Toast.fire({ icon: "error", title: "Erro ao importar contato" });
        }
      }
    };
    
    useEffect(()=>{
      if(!id){
        switch(tipo){
          case 'cliente':
            setTitle('Novo Cliente');
            break;
          default:
            setTitle('Novo Contato');
            break;
        }
      }
      else{
        setTitle(`Editar ${nomeDoCliente}`);
      }
    }, [tipo, nomeDoCliente, id])
    
    useEffect(() => {
        if (id) {
            carregarCliente();
        }
    }, [id]);
    
    useEffect(() => {
      carregarRegioes();
    }, []);
    
    useEffect(() => {
      setLinks(links||[
        //{name:'Teate', to:'/'},
        //{name:'Listar Produtos', icon:'bi-trash', to:'/produtos'},
        //{name:'Alerta Teste', onClick:() => {minhaFuncao('05')}},
      ]);
      setBtns([
        //{icon:'bi-trash', to:'/'},
        //{icon:'bi-trash', to:'/produtos'},
        {icon:'bi-check-lg', onClick:async(e) => {e.preventDefault();await handleSubmit();}},
      ]);
      return () => {setLinks([]); setBtns([]);}
    }, [setLinks, setBtns, handleSubmit]);

    const formatarData = (data) => {
      if(data){
        const parts = data.split('/');
        return `${parts[2]}-${parts[1]}-${parts[0]}`
      }
      return data;
    }
    
    const carregarCliente = async () => {
        try{
          const response = await get(`/gvendas/clientes/${id}/?expand=regiao&filtros=telefone,nome_do_cliente,endereco,posicao_mapa,dia_do_aniversario,ativo,observacoes,crediario,nome,foto_perfil,cpf_cnpj,categoria`,'pagina');
          if (response && response.length){
            const { telefone, cpf_cnpj, nome_do_cliente, endereco, dia_do_aniversario,posicao_mapa, ativo, observacoes, crediario, regiao, foto_perfil, categoria } = response[0];
            setTelefone(telefone||``);
            setNomeDoCliente(nome_do_cliente||``);
            setEndereco(endereco||``);
            setPosicao(posicao_mapa||``);
            setDiaDoAniversario(dia_do_aniversario||'');
            setAtivo(ativo||false);
            setDocumento(cpf_cnpj||``);
            setObservacoes(observacoes||``);
            setCrediario(crediario||false);
            setFoto(foto_perfil||``)
            setRegiao(regiao?.nome||``)
            setCategoriaId(categoria||``)
          }
        }catch(err){

        }finally{

        }
    };
    
    const carregarRegioes = async () => {
        try{
          const response = await get('gvendas/regioes/?ordering=nome&limit=1000&filtros=nome','regioes');
          if (response && response.length){
            setRegioes(response[0].results);
          }
        }catch(err){
          
        }finally{
          
        }
    };

    const pesquisarEndereco = async(input) => {
      try{
        if(input) return; //Bloqueando a conaulta
        const cidade = encodeURIComponent(enderecoAtual?.cidade||`São Paulo`);
        //const cidade = encodeURIComponent('Osasco');
        const uf = encodeURIComponent(enderecoAtual?.uf||`SP`);
        const rua = encodeURIComponent(input?.replace(/[^a-zA-Z0-9À-ÖØ-öø-ÿ]/g, ''));
        
        if (!uf || !rua || rua.length < 3) return;
        
        //const response = await get(`https://viacep.com.br/ws/${uf}/${cidade}/${rua}/json/`,'viacep', false);
        const response = await get(`/core/pesquisar-endereco/?uf=${uf}&cidade=${cidade}&rua=${rua}`,'viacep', false);
        if (response.length > 0){
          setEnderecos(
            response[0].filter((x, index, self) =>
              index === self.findIndex((y) => y.bairro === x.bairro && y.localidade === x.localidade)
            )
          );
          response[0].forEach(item => {
            setRegioes((prevRegiao) => {
              if (!prevRegiao.some((regiao) => regiao.nome === `${item.bairro} - ${item.localidade}`)) {
                return [...prevRegiao, { nome: `${item.bairro} - ${item.localidade}` }];
              }
              return prevRegiao;
            });
          });
        }
      }catch(err){
        
      }
    }

    const buscarLocalizacaoGPS = async () => {
      try {
        if (isNative) {
          // No Nativo, verificamos e solicitamos explicitamente para garantir
          let permStatus = await Geolocation.checkPermissions();
    
          if (permStatus.location !== 'granted') {
            permStatus = await Geolocation.requestPermissions();
          }
    
          if (permStatus.location === 'granted') {
            const coordinates = await Geolocation.getCurrentPosition({
              enableHighAccuracy: true,
              maximumAge: 0 // Força a busca de uma nova posição
            });
            const { latitude, longitude } = coordinates.coords;
            setPosicao(`${latitude},${longitude}`);
            Toast.fire({
              icon: "success",
              title: `Localização marcada com sucesso.`
            });
          }
        } else if (navigator.geolocation) {
          // No Navegador, o próprio navegador gerencia o prompt ao executar esta linha
          navigator.geolocation.getCurrentPosition(
            async (position) => {
              const { latitude, longitude } = position.coords;
              setPosicao(`${latitude},${longitude}`);
              Toast.fire({
                icon: "success",
                title: `Localização marcada com sucesso.`
              });
            },
            (error) => {
              console.error(error);
            },
            {
              enableHighAccuracy: true,
              maximumAge: 0 // Força a busca de uma nova posição no navegador
            }
          );
        }
      } catch (err) {
        console.error('Erro ao buscar endereço:', err);
      }
    };
    
    const buscarEnderecoGPS = async () => {
      try {
        if (isNative) {
          // No Nativo, verificamos e solicitamos explicitamente para garantir
          let permStatus = await Geolocation.checkPermissions();
    
          if (permStatus.location !== 'granted') {
            permStatus = await Geolocation.requestPermissions();
          }
    
          if (permStatus.location === 'granted') {
            const coordinates = await Geolocation.getCurrentPosition({
              enableHighAccuracy: true,
              maximumAge: 0 // Força a busca de uma nova posição
            });
            const { latitude, longitude } = coordinates.coords;
            setPosicao(`${latitude},${longitude}`);
            await buscarEnderecoPosicaoApi(latitude, longitude);
          }
        } else if (navigator.geolocation) {
          // No Navegador, o próprio navegador gerencia o prompt ao executar esta linha
          navigator.geolocation.getCurrentPosition(
            async (position) => {
              const { latitude, longitude } = position.coords;
              setPosicao(`${latitude},${longitude}`);
              await buscarEnderecoPosicaoApi(latitude, longitude);
            },
            (error) => {
              console.error(error);
            },
            {
              enableHighAccuracy: true,
              maximumAge: 0 // Força a busca de uma nova posição no navegador
            }
          );
        }
      } catch (err) {
        console.error('Erro ao buscar endereço:', err);
      }
    };

    const buscarEnderecoPosicaoApi = async (lat, lng) => {
      try {
        const response = await get(
          `/core/endereco-por-geolocalizacao/?lat=${lat}&lng=${lng}`,
          'buscarEnderecoPosicaoApi',
          false
        );
    

        if (response.length === 0) {
          console.error("Endereço não encontrado nos dados da API");
          return;
        }
        const item = response[0];

        setEnderecoAtual(item);
        setEndereco(item.endereco);
        setRegiao(item.regiao);
    
        console.log("Endereço encontrado:", item.endereco);

      } catch (error) {
        //alert("Erro ao buscar endereço: " + error.message);
        console.error("Erro ao buscar endereço:", error);
      }
    };
    
    return (
        <div className="">
            <Card>
                <Card.Body>
                    <Form onSubmit={handleSubmit}>
                        {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}
                        
                        {mais && <ImageCropper foto={foto} setFoto={setFileFoto} radius={50} width={500} height={500} />}

                        <Form.Group controlId="formNomeDoCliente" className="mt-3">
                          <Form.Label>Nome *</Form.Label>
                          <div className="input-group">
                            <Form.Control 
                                type="text" 
                                value={nomeDoCliente} 
                                onChange={(e) => setNomeDoCliente(e.target.value)} 
                            />
                            <Button variant="secondary" onClick={handleImportContacts}><i className="bi bi-journal-arrow-up"></i></Button>
                          </div>
                          {formErrors.nomeDoCliente && <Alert variant="danger">{formErrors.nomeDoCliente}</Alert>}
                        </Form.Group>
                        <PhoneInput phone={telefone} setPhone={setTelefone} formErrors={formErrors} is_obrigatorio={false} label={"WhatsApp"}/>
                        {formErrors.telefone && <Alert variant="danger">{formErrors.telefone}</Alert>}
                        
                        {posicao && (<>
                          <Localizacao localizacao={posicao} />
                        </>)}
                        <Row>
                          <Col xs="auto" className="mx-auto">
                            <InputGroup>
                              <Button 
                                size="sm" 
                                variant="secondary" 
                                onClick={buscarLocalizacaoGPS}
                              >
                                <i className="bx bx-target-lock"></i> Marcar Localização
                              </Button>
                              <Button 
                                size="sm" 
                                variant="secondary" 
                                onClick={buscarEnderecoGPS}
                              >
                                <i className="bx bx-map-pin"></i> Carregar Endereço
                              </Button>
                            </InputGroup>
                          </Col>
                        </Row>

                        
                        {mais && (
                          <>
                            <Form.Group controlId="formDocumento" className="mt-3">
                              <Form.Label>CPF ou CNPJ</Form.Label>
                              <div className="input-group">
                                <Form.Control 
                                    type="text" 
                                    value={documento} 
                                    onChange={(e) => setDocumento(e.target.value)} 
                                />
                              </div>
                              {formErrors.documento && <Alert variant="danger">{formErrors.documento}</Alert>}
                            </Form.Group>
                          </>
                        )}
                        
                        {(endereco || mais) && (<>
                            {tipo === "cliente" && (<>
                              <Form.Group controlId="formEndereco" className="mt-3">
                                  <Form.Label>Endereço</Form.Label>
                                  <div className="input-group">
                                    <Form.Control 
                                        type="text" 
                                        value={endereco} 
                                        onChange={(e) => {setEndereco(e.target.value); pesquisarEndereco(e.target.value)}} 
                                        list="enderecos" 
                                    />
                                    <Button variant="secondary" onClick={buscarEnderecoGPS}><i className="bi bi-geo-alt"></i></Button>
                                  </div>
                                  <datalist id="enderecos">
                                    {enderecos.length > 0 ? (
                                      enderecos.map((item, index) => <option key={index} value={`${item.logradouro}, ${item.bairro} - ${item.localidade}`} />)
                                    ) : null}
                                  </datalist>
                                  {formErrors.endereco && <Alert variant="danger">{formErrors.endereco}</Alert>}
                              </Form.Group>
                              <Form.Group controlId="formRegiao" className="mt-3">
                                  <Form.Label>Local <i className="text-muted small">ex:região, empresa ou bairro</i></Form.Label>
                                  <Form.Control 
                                      type="text"
                                      value={regiao} 
                                      onChange={(e) => setRegiao(e.target.value)} 
                                      list="regioes" 
                                  />
                                  <datalist id="regioes">
                                    {regioes?.length > 0 ? (
                                      regioes.map((item, index) => <option key={index} value={item.nome} />)
                                    ) : null}
                                  </datalist>
                                  {formErrors.regiao && <Alert variant="danger">{formErrors.regiao}</Alert>}
                              </Form.Group>
                              
                            </>)}
                        </>)}
                        {mais && (
                          <>
                            <Form.Group controlId="formDiaDoAniversario" className="mt-3">
                                <Form.Label>Dia do Aniversário</Form.Label>
                                <Form.Control 
                                    type="date" 
                                    value={diaDoAniversario} 
                                    onChange={(e) => setDiaDoAniversario(e.target.value)} 
                                />
                                {formErrors.diaDoAniversario && <Alert variant="danger">{formErrors.diaDoAniversario}</Alert>}
                            </Form.Group>
    
                            {tipo === "cliente" && (<>
                              <SelecionarCategoria defaultText={` `} tipo={`tipo-cliente`} categoriaId={categoriaId} setCategoriaId={setCategoriaId} label="Tipo"/>
                              {formErrors.categoria && <Alert variant="danger">{formErrors.categoria}</Alert>}
                              
                              <Form.Group controlId="formObservacoes" className="mt-3">
                                  <Form.Label>Observações</Form.Label>
                                  <Form.Control 
                                      as="textarea" 
                                      value={observacoes} 
                                      onChange={(e) => setObservacoes(e.target.value)} 
                                      rows={3} 
                                  />
                                  {formErrors.observacoes && <Alert variant="danger">{formErrors.observacoes}</Alert>}
                              </Form.Group>
                            </>)}
                            {(!id && mais && !is_venda) && (
                              <>
                                <Form.Group controlId="formEnvioWhatsApp" className="mt-3">
                                    <Form.Check 
                                        type="switch" 
                                        label="Enviar WhatsApp ao salvar contato"
                                        checked={enviarWhatsApp}
                                        onChange={(e) => setEnviarWhatsApp(e.target.checked)} 
                                    />
                                </Form.Group>
                              </>
                            )}
                            {id && (
                              <>
                                {(ativo && tipo==="cliente") && (
                                  <Form.Group controlId="formCrediario" className="mt-3">
                                      <Form.Check 
                                          type="switch" 
                                          label="Crediário"
                                          checked={crediario}
                                          onChange={(e) => setCrediario(e.target.checked)}
                                      />
                                      {formErrors.crediario && <Alert variant="danger">{formErrors.crediario}</Alert>}
                                  </Form.Group>
                                )}
                                <Form.Group controlId="formAtivo" className="mt-3">
                                    <Form.Check 
                                        type="switch" 
                                        label="Ativo"
                                        checked={ativo}
                                        onChange={(e) => {setAtivo(e.target.checked); if(!e.target.checked) setCrediario(false);}} 
                                    />
                                    {formErrors.ativo && <Alert variant="danger">{formErrors.ativo}</Alert>}
                                </Form.Group>
                              </>
                            )}
                          </>
                        )}
                        {!mais && (
                          <>
                            {!is_venda && (<>
                              <Form.Group controlId="formEnvioWhatsApp" className="mt-3">
                                  <Form.Check 
                                      type="switch" 
                                      label="Enviar WhatsApp ao salvar contato"
                                      checked={enviarWhatsApp}
                                      onChange={(e) => setEnviarWhatsApp(e.target.checked)} 
                                  />
                              </Form.Group>
                            </>)}
                            <div className="text-center">
                              <Button variant="outline-secondary" onClick={()=>setMais(true)} className="mt-4 btn-sm">
                                  Mais <i className="bi bi-caret-down"></i>
                              </Button>
                            </div>
                          </>
                        )}


                        <Button variant="secondary" type="submit" className="mt-4 w-100" disabled={loading}>
                            Salvar {" "}
                            {!tipo && "Contato"}
                            {tipo === "cliente" && "Cliente"}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};

export default ClienteForm;